const translations = {
  // SEO
  siteTitle: "Shopee Thailand Data Challenge 2020",
  siteDesc:
    "บริษัทช้อปปี้ ประเทศไทยจับมือพันธมิตรเชิญชวนนักเรียน นิสิต นักศึกษา และบุคคลทั่วไปที่มีความสนใจในทักษะการวิเคราะห์ข้อมูล (Data Analytics) ร่วมสมัครเข้าแข่งขันในรายการ Thailand Data Challenge 2020 การแข่งขันวิเคราะห์ข้อมูลเชิงธุรกิจที่ใหญ่ที่สุดในประเทศไทย เพื่อชิงเงินรางวัลเงินสด และ Shopee Coins รวมมูลค่ากว่า 100,000 บาท พร้อมทริปเยี่ยมชมสำนักงานใหญ่ ช้อปปี้ ณ ประเทศสิงคโปร์ สุด Exclusive ทั้งนี้ผู้สมัครเข้าแข่งขัน Data Analytics จะมีสิทธิ์ลงทะเบียนเข้าอบรมและทำ workshop ด้าน coding และ data analytics ที่ถูกออกแบบมาโดยเฉพาะจากพันธมิตรด้านการฝึกอบรมจาก startups และองค์กรชั้นนำของประเทศไทย อาทิ BotNoi, Career Visa, Data Cafe, Microsoft, Skooldio และ Software Park อย่าช้า!! ที่นั่งมีจำนวนจำกัด!! เพียงฟอร์มทีม 2-4 คน แล้วลงทะเบียนทีมที่ https://careers.shopee.co.th/thdatachallenge/ โดยเลือกประเภทการแข่งขันให้ถูกต้อง (นักเรียนระดับมัธยมศึกษาและอนุปริญญา, นิสิต-นักศึกษาระดับปริญญาตรี และบุคคลทั่วไป) และเลือกหลักสูตร หรือ workshops ที่สนใจ แล้วเตรียมตัวให้พร้อมสำหรับการแข่งขันในวันเสาร์ที่ 28 มีนาคม 2563 ที่ ยูเนี่ยน ฮอลล์ ศูนย์การค้ายูเนี่ยน มอลล์",
  siteURL: "https://careers.shopee.co.th/thdatachallenge",
  siteImageURL:
    "https://careers.shopee.co.th/thdatachallenge/images/header_seo.png",
  seoStartdate: "2020-02-29 T00:00+07:00",
  seoEnddate: "2020-03-28 T23:59+07:00",
  seoPerformer: "Shopee Indonesia",
  seolocationName: "Shopee Indonesia",
  seolocationAddress: "ndsc.id@shopee.com",
  seohasMap: "",
  seoAudienceType: "Para pekerja dan pelajar yang tertarik dengan Data!",
  // Nav
  navAbout: "เกี่ยวกับ",
  navCategory: "ประเภทการแข่งขัน",
  navPrizes: "รางวัล",
  navTimeline: "ระยะเวลารับสมัคร",
  navFaq: "FAQ",
  navPartners: "พันธมิตร",
  navContact: "ติดต่อสอบถาม",
  navCareer: "สมัครงาน",
  careerLink: "https://careers.shopee.co.id/",
  //Hero
  dateRange: "21 Maret 2020",
  heroDesc: "Kompetisi data science terbesar di Indonesia",
  //Intro
  introduction: "แนะนำโครงการ",
  introDesc01:
    "Thailand Data Challenge 2020 คือการแข่งขันที่จัดขึ้นเพื่อเฟ้นหาทีมที่สามารถใช้ทักษะการโค้ดดิ้งและการวิเคราะห์ข้อมูล (Data Analysis)เพื่อแก้โจทย์ได้เร็ว ถูกต้องและแม่นยำที่สุด",
  introDesc01p: "วัตถุประสงค์ของการแข่งขัน จัดขึ้นโดยมีวัตถุประสงค์หลักคือ",
  introLi01:
    "เตรียมนักเรียนนักศึกษา บุคลากรทั่วไปและผู้เชี่ยวชาญด้าน Data Analytics ให้พร้อมรับยุคเศรษฐกิจดิจิทัล",
  introLi02:
    "รวบรวมและเปิดพื้นที่ให้ชุมนุมกลุ่ม(สังคม)เทคโนโลยี (Tech Communities) ได้มีโอกาสสร้างประสบการณ์ใหม่ๆ และแชร์ความรู้ทักษะที่จำเป็นในยุคดิจิทัลให้แก่กันและกัน",
  introLi03:
    "เปิดโอกาสให้ผู้เข้าร่วมแข่งขันได้ทำการวิเคราะห์ข้อมูลจากข้อมูลที่เกิดขึ้นจริงในธุรกิจอีคอมเมิร์ซ",
  introData: [
    {
      title: "ทำไมคุณจึงไม่ควรพลาด Thailand Data Challenge 2020? ",
      image: "about-01.png",
      desc:
        "การแข่งขัน Thailand Data Challenge 2020 ออกแบบและจัดขึ้นโดยเฉพาะให้ผู้ที่ชื่นชอบเทคโนโลยีและหลงใหลการโค้ดดิ้งและการวิเคราะห์ข้อมูล (Data Analysis)ได้มีโอกาสพัฒนาศักยภาพและทักษะการโค้ดดิ้งและการวิเคราะห์ข้อมูล (Data Analysis)ผ่านการเข้าร่วมเทรนนิ่งและเวิร์คชอร์ป รวมถึงการทำโจทย์ที่เกิดขึ้นจริงในธุรกิจของเรา"
    },
    {
      title: "คุณสมบัติผู้เข้าแข่งขัน",
      image: "about-02.png",
      desc:
        "Thailand Data Challenge 2020 เปิดรับสมัครผู้เข้าแข่งขันจากทุกๆประเภทในทุกเพศ ทุกระดับการศึกษา ทุกสัญชาติ เพียงคุณกำลังศึกษาหรือทำงานในประเทศไทย",
      desc02:
        "เพื่อความเที่ยงธรรมของการแข่งขัน พนักงานในเครือ Sea Group จะไม่ได้รับอนุญาตให้สมัครเข้าร่วมในการแข่งขันนี้ในทุกกรณี"
    },
    {
      title: "รูปแบบการสมัคร",
      image: "about-03.png",
      desc:
        "สมัครเข้าร่วมการแข่งขันเป็นทีมเท่านั้น โดยทีมของคุณจะต้องมีสมาชิก 2-4 คนต่อ 1 ทีม ไม่มีค่าใช้จ่ายใดๆทั้งสิ้น!"
    },
    {
      title: "สิทธิประโยชน์อื่นๆ",
      image: "about-04.png",
      desc:
        "ผู้ที่สมัครเข้าร่วมเข้าแข่งขันก่อนจะมีสิทธิเลือกคอร์สที่จะเข้าเทรนนิ่งและเวิร์คช็อปก่อนใคร เทรนนิ่งและเวิร์คช็อปที่จัดขึ้นออกแบบมาโดยเฉพาะจาก Training Partners ของเราเพื่อ Thailand Data Challenge 2020 เท่านั้น"
    }
  ],
  introAbout: "รายละเอียดการแข่งขัน",
  introAboutDesc01:
    "Thailand Data Challenge 2020 คือ การแข่งขันการวิเคราะห์ข้อมูล (Data Analysis)โดยการใช้การโค้ดดิ้งเพื่อแก้โจทย์ที่นำมาจากปัญหาที่เกิดขึ้นจริง",
  introAboutDesc02:
    "การแข่งขันจะแบ่งเป็นทั้งหมด 2 รอบด้วยกันโดยผู้เข้าแข่งขันจะต้องวิเคราะห์ หาข้อสรุปและแก้ไขปัญหาจากโจทย์ในระยะเวลาที่จำกัด  โจทย์ของการแข่งขันนี้จะถูกออกแบบโดย ทีม Shopee Tech",
  introAboutDesc03:
    "ผู้เข้าแข่งขันจะได้มีโอกาสใช้ทักษะการโค้ดดิ้งเพื่อแก้โจทย์ทางธุรกิจที่เกิดขึ้นจริงและได้ท้าทายความสามารถของตนเองในสถานการณ์การแข่งขันจริงอีกด้วย",
  categories: "ประเภทของผู้เข้าแข่งขัน",
  categoriesData: [
    {
      image: "images/theme-01.png",
      title: [
        "ประเภท 1",
        "(Pre-Tertiary)",
        "นักเรียนนักศึกษาระดับอนุปริญญาและมัธยมศึกษา"
      ],
      list: [
        "สำหรับนักเรียนนักศึกษาระดับมัธยมศึกษา อนุปริญญา(เทคนิค อาชีวศึกษา)"
      ]
    },
    {
      image: "images/theme-02.png",
      title: ["ประเภท 2", "(Undergraduates)", "นักเรียนนักศึกษาระดับปริญญาตรี"],
      list: ["สำหรับนักเรียนนักศึกษาที่กำลังศึกษาในระดับปริญญาตรี"]
    },
    {
      image: "images/theme-03.png",
      title: ["ประเภท 3", "(Open)", "บุคคลทั่วไป"],
      list: ["สำหรับบุคคลทั่วไป หรือกำลังศึกษาในระดับปริญญาโทหรือสูงกว่า"]
    }
  ],
  //prize
  prizes: "รางวัล",
  prizesTitle1:
    "สำหรับประเภท 1 (Pre-Tertiary) : นักเรียนนักศึกษาระดับอนุปริญญาและมัธยมศึกษา",
  prizesData: [
    {
      name: "ชนะเลิศ",
      image: "images/icon_reward.svg",
      price: "เงินรางวัล 40,000 บาท และ 20,000 Shopee Coins",
      list: [
        "ทริปเพื่อเยี่ยมชมออฟฟิศของ Shopee ที่สิงคโปร์ ที่พักพร้อมตั๋วเครื่องบินไปกลับ",
        "โอกาสในการเข้าสัมภาษณ์เพื่อทำงานหรือฝึกงานกับ Shopee"
      ]
    }
  ],
  prizesTitle2:
    "ประเภท 2 (Undergraduates) : นักเรียนนักศึกษาระดับปริญญาตรี และประเภท 3 (Open) : บุคคลทั่วไป",
  prizesData2: [
    {
      name: "ชนะเลิศรางวัลที่ 1",
      image: "images/icon_reward.svg",
      price: "เงินรางวัล 70,000 บาท และ 30,000 Shopee Coins",
      list: [
        "ทริปเพื่อเยี่ยมชมออฟฟิศของ Shopee ที่สิงคโปร์ ที่พักพร้อมตั๋วเครื่องบินไปกลับ",
        "โอกาสในการเข้าสัมภาษณ์เพื่อทำงานหรือฝึกงานกับ Shopee"
      ]
    },
    {
      name: "รองชนะเลิศอันดับ 1",
      image: "images/prize-01.png",
      price: "เงินรางวัล 50,000 บาท",
      list: ["โอกาสในการเข้าสัมภาษณ์เพื่อทำงานหรือฝึกงานกับ Shopee"]
    },
    {
      name: "รองชนะเลิศอันดับ 2",
      image: "images/prize-02.png",
      price: "เงินรางวัล 25,000 บาท",
      list: ["โอกาสในการเข้าสัมภาษณ์เพื่อทำงานหรือฝึกงานกับ Shopee"]
    }
  ],
  prizesNote:
    "ผู้เข้าแข่งขันทุกคนที่สามารถส่งคำตอบได้ทันเวลาที่กำหนดไว้ในการแข่งขันจะได้รับประกาศนียบัตรรับรองการเข้าร่วม Thailand Data Challenge 2020",
  prizesNote02:
    "ผู้เข้าแข่งขันมีโอกาสในการเข้าทำงานหรือฝึกงานกับ Shopee ทั้งนี้ทั้งนั้นผู้เข้าแข่งขันจะต้องผ่านขั้นตอนการคัดเลือกตามกฎเกณฑ์ของบริษัท",
  // //Judge
  // judges: "Juri",
  // by: "oleh",
  // judgesDesc:
  //   "Para juri akan memilih tim dari masing-masing kategori dengan solusi yang terunik dan kreatif.",
  // judgesData: [
  //   {
  //     name: "Denny, S.Kom., M.I.T., Ph.D.",
  //     image: "judge-denny.jpg",
  //     link: "",
  //     title: "Direktur Fakultas Ilmu Komputer, Universitas Indonesia",
  //     desc:
  //       "Denny adalah Direktur Fakultas Ilmu Komputer di Universitas Indonesia yang mendapatkan gelar S3 nya dari Australian National University di tahun 2013. Riset pertamanya berhasil diterbitkan di Advances in Knowledge Discovery and Data Mining, dan sekarang beliau sudah menerbitkan lebih dari 10 riset berhubungan dengan Data Mining, Database Systems, dan Computational Intelligence. Beliau mengajar Advanced Algorithms, Data Structures, and Big Data courses."
  //   },
  //   {
  //     name: "Lektor Kepala Imas Sitanggang",
  //     image: "judge-imas.jpg",
  //     link: "",
  //     title: "Dosen Fakultas Ilmu Komputer, Institut Pertanian Bogor",
  //     desc:
  //       "Imas Sitanggang adalah Dosen Fakultas Ilmu Komputer di Institut Pertanian Bogor. Beliau memiliki minat yang kuat di Data Mining, Spatial Data Processing, dan aplikasinya terhadap model risiko kebakaran hutan dan lahan. Beliau dipercayai dengan berbagai tunjangan riset dari berbagai institusi dan aktif serta dalam program fellowship di bidangnya."
  //   },
  //   {
  //     name: "Ivan Wangsa",
  //     image: "judge-ivan.jpg",
  //     link: "",
  //     title: "Head of Business Intelligence, Shopee",
  //     desc:
  //       "Ivan Wangsa adalah Head of Business Intelligence di Shopee Indonesia, memimpin tim yang terdiri lebih dari 50 Data Analis dan Engineers dan memiliki fokus yang kuat pada data.  Setelah mendapatkan gelar sarjana Matematika dari Nanyang Technological University di Singapura, beliau memulai kariernya di Sea di tahun 2015, dengan pengalaman dari berbagai lini bisnis Sea (Corporate, Garena, Shopee, AirPay)."
  //   },
  //   {
  //     name: "Dr. Alexander Gunawan",
  //     image: "judge-alexander.jpg",
  //     link: "",
  //     title:
  //       "Ketua Jurusan, Teknik Informatika-Matematika dan Teknik Informatika-Statistika, Universitas Bina Nusantara",
  //     desc:
  //       "Dr. Alexander Gunawan adalah seorang Ilmuwan Komputer dan Ahli Matematika. Beliau memiliki minat untuk Artificial Intelligence dan mahir dalam Deep Learning dan kerangka Bayesian. Dalam disertasinya, beliau mengeksploitasi kerangka Bayesian untuk mengembangkan algoritma yang cepat dan optimal dalam Visual Object Tracking. Beliau juga memiliki wawasan dalam Industri Robotika dan Autonomous Mobile Robots, serta Natural Language Processing yang telah menuntunnya dalam beberapa riset mengenai subjek tersebut. Beliau juga rutin membuat ulasan untuk jurnal internasional."
  //   }
  // ],
  //Timeline
  timeline: "ระยะเวลาในการเปิดรับสมัคร",
  timelineData: [
    {
      date: "25 มกราคม 2563",
      desc: "เปิดรับสมัคร"
    },
    {
      date: "8 มีนาคม 2563",
      desc: "ปิดรับสมัคร"
    },
    {
      date: ["17 กุมพาพันธ์ 2563", "- 14 มีนาคม 2563"],
      desc: "คลาสฝึกอบรมและทำเวิร์คช้อป"
    },
    {
      date: "รอการยืนยัน",
      desc: "วันแข่งขัน  Thailand Data Challenge 2020"
    }
  ],
  //training workshop
  trainingWorkshops: "การฝึกอบรมและเวิร์คช้อป",
  trainingDesc:
    "เพียงกดสมัครเข้าร่วมการแข่งขัน คุณจะได้รับอัพเดตเกี่ยวกับโปรแกรมเทรนนิ่งและเวิร์คช็อปสุดพิเศษที่กำลังจะจัดขึ้น คุณจะได้รับอีเมลล์แจ้งรายละเอียดเพิ่มเติมเกี่ยวกับโปรแกรมเทรนนิ่งเวิร์คช็อปและผู้ที่ได้รับอีเมลล์ยืนยันจากทางเราเท่านั้น จึงสามารถเข้าร่วมเทรนนิ่งได้",
  trainingDescRegister: "Daftarkan diri Anda di",
  link: "sini",
  trainingData: [
    {
      date: "Sabtu, 22 Feb 2020 10.00-13.00",
      name: "Advanced Training",
      organizer: "Make-AI",
      state: "",
      location: "Jakarta",
      list: ["Less stressful Deep Learning dengan ReNom"]
    },
    {
      date: "Sabtu, 22 Feb 2020 10.00-13.00",
      name: "Beginner Training",
      organizer: "Make-AI",
      state: "",
      location: "Jakarta",
      list: [
        "Pembelajaran Strategi Data Science (Introduction to Python, Introduction to DS and Machine learning)",
        "Belajar Machine Learning dengan Mudah (Linear Models (regression), Tree-based Models dan Ensemble Learning)"
      ]
    },
    {
      date: "Kamis - Sabtu, 6 - 8 Feb 2020 09.00-16.00",
      name: "Beginner Training",
      organizer: "Arkademy",
      state: "",
      location: "Jakarta",
      list: [
        "Introduksi Python",
        "Eksploratori Data Analysis",
        "Prinsip Data Science",
        "Supervised Learning",
        "Unsupervised Learning"
      ]
    },
    {
      date: "Sabtu, 7 Mar 2020 10.00-14.00",
      name: "Beginner Training",
      organizer: "Hacktiv8",
      state: "",
      location: "Jakarta",
      list: [
        "Gambaran Recommendation System",
        "Content-Based Filtering",
        "Collaborative Filtering",
        "Matrix Decomposition",
        "Matriks Evaluasi untuk Recommendation System"
      ]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: "Binar Academy",
      state: "",
      list: ["Tunggu informasi lebih lanjut mengenai program dari kami!"]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: "DQLab",
      state: "",
      list: ["Tunggu informasi lebih lanjut mengenai program dari kami!"]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: "Dicoding Indonesia",
      state: "",
      location: "Online",
      registerLink: "https://www.dicoding.com/academies/86",
      list: ["Memulai Pemrograman Dengan Python"]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: " Sekolah Koding",
      state: "",
      location: "Online",
      registerLink:
        "https://sekolahkoding.com/track/belajar-python-bahasa-indonesia",
      list: [
        "Belajar Python untuk Pemula",
        "Bermain dengan File di Python",
        "Database di Python dengan Peewee"
      ]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: "Botika Online",
      state: "",
      list: ["Tunggu informasi lebih lanjut mengenai program dari kami!"]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: "Bitlabs.id",
      state: "",
      location: "Jakarta",
      list: [
        "R intro",
        "Data preparation",
        "Simple linear regression",
        "Multiple linear regression",
        "Performance measurement",
        "Hands on linear regression (google spreadsheet + rstudio)"
      ]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: "Clevio Coder Camp",
      state: "",
      list: [
        "Apa itu Data Science?",
        "Apa itu Web Scraping?",
        "Mengapa Data Scraping?",
        "Apakah Data Scraping Legal?",
        "Mengapa Harus Menggunakan Python?",
        "Bagaimana Caranya Bekerja? ",
        "Kebutuhan Libraries di Python",
        "Mengetahui Informasi Dasar Mengenai Python",
        "Syarat Installing",
        "Memilih Website Untuk Scrapping",
        "Memeriksa Halaman",
        "Mencari Data Untuk Scrapping",
        "Menulis Code"
      ]
    },
    {
      date: "",
      name: "Beginner Training",
      organizer: "G2 Academy",
      state: "",
      list: ["Introduksi NLTK", "Introduksi Big Data"]
    }
  ],
  // Register
  register: "สมัครเลย!",
  registerNow: "สมัครเลย",
  registerDuration: [
    "เปิดรับสมัครตั้งแต่วันที่  ",
    "25 มกราคม 2563",
    " จนถึงวันที่ ",
    "8 มีนาคม 2563"
  ],
  registerNowDesc:
    "เตรียมตัวให้พร้อมสำหรับการแข่งขัน data analytics ครั้งสำคัญ สมัครเลยตอนนี้!",
  registerClose: "Thailand Data Challenge ปิดรับสมัคร",
  //partner
  partners: "พันธมิตร",
  organized: "จัดโดย",
  organizedData: [
    {
      name: "Shopee Thailand",
      image: "shopee_logo_en.png",
      link: "https://careers.shopee.co.th/"
    }
  ],
  govPartner: "พันธมิตร หน่วยงานภาครัฐบาล",
  govPartnerData: [
    {
      name: "กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม",
      image: "Ministry_of_Digital_Economy_and_Society_of_Thailand.png",
      link: "https://www.mdes.go.th/"
    },
    {
      name: "สำนักงานส่งเสริมเศรษฐกิจดิจิทัล",
      image: "DEPA.jpg",
      link: "https://www.depa.or.th/th/home"
    },
    {
      name: "สำนักงานนวัตกรรมแห่งชาติ",
      image: "nia_logo.jpg",
      link: "https://www.nia.or.th/"
    }
  ],
  mediaPartner: "พันธมิตรด้านสื่อ",
  mediaPartnerData: [
    {
      name: "แบไต๋",
      image: "logo_beartai.png",
      link: "https://www.beartai.com/"
    }
  ],
  trainingPartners: "พันธมิตรด้านการฝึกอบรม",
  trainingPartnersData: [
    {
      name: "Career Visa",
      image: "logo_careervisa.png",
      link: "https://web.careervisathailand.com/"
    },
    {
      name: "BotNoi",
      image: "botnoi_logo.png",
      link: "http://www.botnoigroup.com/"
    },
    {
      name: "Data Cafe’",
      image: "Data-Cafe-logo.png",
      link: "http://www.datacafethailand.com/"
    },
    {
      name: "เอ็ดวิงส์ เอ็ดยูเคชั่น",
      image: "EdWings.png",
      link: "http://edwings.co/"
    },
    {
      name: "Here Technologies",
      image: "HERE_Logo_2016_POS_cmyk_IsoCV2.png",
      link: "https://www.here.com/"
    },
    {
      name: "Microsoft Thailand",
      image: "MSFT_logo.png",
      link: "https://www.microsoft.com/th-th"
    },
    {
      name: "Skooldio",
      image: "skooldio-logo.png",
      link: "https://www.skooldio.com/"
    },
    {
      name: "Software Park Thailand",
      image: "softwarepark.png",
      link: "http://www.swpark.or.th/"
    },
    {
      name: "ศูนย์วิจัยและพัฒนาเทคโนโลยีเพื่ออุตสาหกรรม จุฬาลงกรณ์มหาวิทยาลัย",
      image: "utc_logo.jpg",
      link: "https://www.research.chula.ac.th/"
    },
    {
      name: "ZYMPLE",
      image: "ZYMPLE-logo.png",
      link: "https://zymple.biz/"
    }
  ],
  universityPartners: "พันธมิตรฝ่ายการศึกษา",
  universityPartnersData: [
    {
      name: "มหาวิทยาลัยอัสสัมชัญ",
      image: "Assumption University.png",
      link: "http://www.au.edu/"
    },
    {
      name: "มหาวิทยาลัยกรุงเทพ",
      image: "Bangkok University.png",
      link: "https://www.facebook.com/BU.International/"
    },
    {
      name: "คณะพาณิชยศาสตร์และการบัญชี จุฬาลงกรณ์มหาวิทยาลัย",
      image: "CBS.jpg",
      link: "https://www.cbs.chula.ac.th/en/"
    },
    {
      name: "คณะวิศวกรรมศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย",
      image: "Chulalongkorn University_Computer Engineering.png",
      link: "https://www.eng.chula.ac.th/en/"
    },
    {
      name: "คณะวิทยาศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย",
      image: "CU SCI.png",
      link: "http://web.sc.chula.ac.th/index.php"
    },
    {
      name:
        "ภาควิชาคณิตศาสตร์และวิทยาการคอมพิวเตอร์ คณะวิทยาศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย",
      image: "math.sc.chula.logo.png",
      link: "https://math.sc.chula.ac.th/"
    },
    {
      name: "Kaplan",
      image: "Kaplan.png",
      link: "https://www.kaplaninternational.com/"
    },
    {
      name: "สตาร์ อี.ดี.ยู.",
      image: "Kaplan_cep.jpg",
      link: "http://www.kapstar.com/"
    },
    {
      name: "คณะเศรษฐศาสตร์ มหาวิทยาลัยขอนแก่น",
      image: "Econ KKU.png",
      link: "https://econ.kku.ac.th/app/webroot/cro/"
    },
    {
      name: "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง",
      image: "kmitl_logo.png",
      link: "https://www.kmitl.ac.th/en"
    },
    {
      name:
        "หลักสูตรวิศวกรรมนวัตกรรมคอมพิวเตอร์ คณะวิศวกรรมศาสตร์ สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง ",
      image: "kmitl_cie_logo.jpg",
      link: "https://cie.kmitl.ac.th/"
    },
    {
      name:
        "คณะเทคโนโลยีสารสนเทศ สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง",
      image: "IT KMITL_LOGO.jpg",
      link: "https://www.it.kmitl.ac.th/en/"
    },
    {
      name: "มหาวิทยาลัยเทคโนโลยีมหานคร",
      image: "MUT_Backup.png",
      link: "http://www.mut.ac.th/"
    },
    {
      name: "คณะบัญชีและการจัดการ มหาวิทยาลัยมหาสารคาม",
      image: "Mahasarakarn-University-_Accounting.png",
      link: "http://www.mbs.msu.ac.th/"
    },
    {
      name: "มหาวิทยาลัยมหาสารคาม",
      image: "MSU Logo.jpg",
      link: "http://www.msu.ac.th/exslides.php"
    },
    {
      name: "วิทยาลัยนานาชาติ มหาวิทยาลัยมหิดล",
      image: "Mahidol.png",
      link: "https://muic.mahidol.ac.th/eng/"
    },
    {
      name: "มหาวิทยาลัยนเรศวร",
      image: "NULOGO-Download-EN.png",
      link: "https://www.nu.ac.th/?page_id=15142&lang=en"
    },
    {
      name: "คณะบริหารธุรกิจ เศรษฐศาสตร์และการสื่อสาร มหาวิทยาลัยนเรศวร",
      image: "BEC NU.jpg",
      link: "http://www.bec.nu.ac.th/cutwebb/"
    },
    {
      name: "มหาวิทยาลัยศรีนครินทรวิโรฒ",
      image: "Srinakharinwirot_Logo_TH_Color.jpg",
      link: "https://www.swu.ac.th/en/"
    },
    {
      name: "คณะเศรษฐศาสตร์ มหาวิทยาลัยศรีนครินทรวิโรฒ",
      image: "swu-logo.png",
      link: "http://econ.swu.ac.th/"
    },
    {
      name: "สถาบันเทคโนโลยีนานาชาติสิรินธร มหาวิทยาลัยธรรมศาสตร์",
      image: "SIIT.jpg",
      link: "https://www.siit.tu.ac.th/"
    },
    {
      name: "คณะพาณิชยศาสตร์และการบัญชี มหาวิทยาลัยธรรมศาสตร์",
      image: "ThammasatBusinessSchool.png",
      link: "http://www.bba.tbs.tu.ac.th/"
    },
    {
      name: "มหาวิทยาลัยธรรมศาสตร์",
      image: "TU.png",
      link: "https://tu.ac.th/en"
    }
  ],
  techPartners: "พันธมิตรกลุ่ม(สังคม)เทคโนโลยี",
  techPartnersData: [
    {
      name: "Codesanook",
      image: "AW_LOGO_codesanook_ALL.png",
      link: "https://www.facebook.com/codesanookpage/"
    },
    {
      name: "CUPy",
      image: "cupy_logo.png",
      link: "https://www.facebook.com/cupy2019/"
    },
    {
      name: "Data Cube",
      image: "DataCube.png",
      link: "https://www.facebook.com/datacube.th/"
    },
    {
      name: "Data Science Thailand",
      image: "DataScienceLab.jpg",
      link: "https://www.facebook.com/DataScienceTh/"
    },
    {
      name: "สมาคมโปรแกรมเมอร์ไทย",
      image: "Thai Programmer.png",
      link: "https://www.thaiprogrammer.org/"
    },
    {
      name: "Software Engineering Thailand",
      image: "amdis_logo_final_.png",
      link: "http://www.amdis-services.com/"
    },
    {
      name: "Facebook Developer Circle (DevC) Bangkok",
      image: "dev_c.jpg",
      link: "https://www.facebook.com/groups/DevCBangkok/"
    },
    {
      name: "Katinrun",
      image: "katinrun-logo.png",
      link: "https://www.facebook.com/Katinrun/"
    },
    {
      name: "KULAP",
      image: "kulap_logo.png",
      link: "https://www.kulap.io/"
    }
  ],
  diversityPartners: "Partners in diversities",
  diversityPartnersData: [
    {
      name: "Girls Who Dev",
      image: "GWD_2017LOGO.png",
      link: "https://www.facebook.com/girlswhodev/"
    },
    {
      name: "PyLadies Bangkok",
      image: "pyladiesbkkfin.png",
      link: "https://www.facebook.com/pyladiesbkk/"
    },
    {
      name: "Women Who Code Bangkok",
      image: "WWCode_Logo.png",
      link: "https://www.womenwhocode.com/"
    }
  ],
  supportPartners: "พันธมิตรร่วมสนับสนุน",
  supportPartnersData: [
    {
      name: "สถาบันกวดวิชาออนดีมานด์",
      image: "ondemand.png",
      link: "https://www.ondemand.in.th/"
    },
    {
      name: "สิงห์ เอสเตท",
      image: "Singha Estate.png",
      link: "https://www.singhaestate.co.th/en#intro"
    }
    // {
    //   name: "SAMSUNG Thailand",
    //   image: "Samsung.png",
    //   link: "https://www.samsung.com/th/"
    // }
  ],
  // studentPartners: "Mitra Komunitas Mahasiswa",
  // studentPartnersData: [
  //   {
  //     name: "Bina Nusantara Computer Club",
  //     image: "bncc_logo.png",
  //     link: "https://bncc.net/"
  //   },
  //   {
  //     name: "BEM FIB Universitas Indonesia",
  //     image: "bemfib_logo.png",
  //     link: "https://www.instagram.com/bemfibui/?hl=en"
  //   },
  //   {
  //     name: "Binus TV",
  //     image: "binus_tv_logo.png",
  //     link: "http://www.binus.tv/"
  //   },
  //   {
  //     name: "Binus Game Development Club",
  //     image: "binus_game_logo_2.png",
  //     link: "http://scdc.binus.ac.id/bgdc"
  //   },
  //   {
  //     name: "Lembaga Mahasiswa Psikologi UGM",
  //     image: "lembaga_logo.png",
  //     link: "https://psikologi.ugm.ac.id/lembaga-mahasiswa-psikologi/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Psikologi Atma Jaya",
  //     image: "himapsi_logo.png",
  //     link: "https://himapsifpuaj.wordpress.com/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Statistika Binus",
  //     image: "himstat_logo.png",
  //     link: "https://www.instagram.com/himstat/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Sistem Informasi Binus",
  //     image: "himsisfo_logo.png",
  //     link: "https://www.instagram.com/himsisfo_binus/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Komputerisasi Akutansi Binus",
  //     image: "himka_logo.png",
  //     link: "https://www.instagram.com/himka_binus/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Sistem Komputer Binus",
  //     image: "himtek_logo.png",
  //     link: "https://www.instagram.com/himtek.binus/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Teknik Sipil Binus",
  //     image: "himtes_logo.png",
  //     link: "https://www.instagram.com/himtesbinus/"
  //   },
  //   {
  //     name: "Unit kegiatan Mahasiswa B-Preneur Binus",
  //     image: "bpreneur_logo.png",
  //     link: "https://www.instagram.com/b.preneur/"
  //   },
  //   {
  //     name: "Binus English Club",
  //     image: "benc_logo_2.png",
  //     link: "https://www.instagram.com/binusenglishclub/?hl=en"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Communication Department Binus",
  //     image: "himmcomm_logo.png",
  //     link: "https://www.instagram.com/himmcommbinus/?hl=en"
  //   },
  //   {
  //     name: "Cyber Security Community Binus",
  //     image: "cyber_security_logo.png",
  //     link: "https://www.instagram.com/cscbinus/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Matematika Binus",
  //     image: "himmat_logo.png",
  //     link: "https://www.instagram.com/himmat_binus/"
  //   },
  //   {
  //     name: "Badan Eksekutif Mahasiswa ITDEL",
  //     image: "bem_logo.png",
  //     link: "https://www.instagram.com/bem.itdel/"
  //   },
  //   {
  //     name: "Del Cyber Army ITDEL",
  //     image: "dca_itdel_logo.png",
  //     link: "https://www.facebook.com/DelCyberArmy/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Teknik Bioproses ITDEL",
  //     image: "himator_itdel_logo.png",
  //     link: "http://instagram.com/himator_itdel/"
  //   },
  //   {
  //     name: "Del Robotic Club ITDEL",
  //     image: "drc_itdel_logo.png",
  //     link: "http://instagram.com/drc_itdel/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Informatika ITDEL",
  //     image: "himasti_itdel_logo.png",
  //     link: "https://www.instagram.com/himasti_itdel/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Sistem Informasi ITDEL",
  //     image: "himsi_itdel_logo.png",
  //     link: "https://www.instagram.com/himsi.itdel_/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Teknologi Komputer ITDEL",
  //     image: "himatek_itdel_logo.png",
  //     link: "https://www.instagram.com/himatek.itdel/?hl=en"
  //   },
  //   {
  //     name: "Crossover Radio ITDEL",
  //     image: "crossover_itdel_logo.png",
  //     link: "https://www.instagram.com/crossover.ukm.del/"
  //   },
  //   {
  //     name:
  //       "Himpunan Mahasiswa Sarjana Terapan Teknologi Rekayasa Perangkat Lunak ITDEL",
  //     image: "himatera_itdel_logo.png",
  //     link: "http://instagram.com/himademtika/"
  //   },
  //   {
  //     name: "Del Programming Club ITDEL",
  //     image: "delpro_itdel_logo.png",
  //     link: "https://www.instagram.com/delproclub/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Teknologi Informasi ITDEL",
  //     image: "himatif_itdel_logo.png",
  //     link: "https://www.instagram.com/himatif.itdel/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Teknik Elektro ITDEL",
  //     image: "hme_itdel_logo.png",
  //     link: "http://hme.del.ac.id/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Ilmu Komputer IPB",
  //     image: "himalkom_ipb_logo.png",
  //     link: "https://www.instagram.com/himalkomipb/"
  //   },
  //   {
  //     name: "Gamma Sigma Beta (HIMSTAT) IPB",
  //     image: "gsb_ipb_logo.png",
  //     link: "https://www.instagram.com/gsb_ipb/"
  //   },
  //   {
  //     name: "BEM Fakultas Vokasi ITS",
  //     image: "bem_its_logo.png",
  //     link: "https://www.instagram.com/bemfv_its/?hl=en"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Program Studi Teknik Elektro Mekatronika UNPAR",
  //     image: "mekatronika_logo.png",
  //     link: "https://www.instagram.com/hmpstem/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Program Studi Teknik Informatika UNPAR",
  //     image: "tif_unpar_logo.png",
  //     link: "http://instagram.com/hmpstif_unpar/"
  //   },
  //   {
  //     name: "Lembaga Kepresidenan Mahasiswa UNPAR",
  //     image: "lkm_unpar_logo.png",
  //     link: "https://www.instagram.com/lkm_unpar/"
  //   },
  //   {
  //     name: "Persatuan Mahasiswa UNPAR ",
  //     image: "pm_unpar_logo.png",
  //     link: "https://www.instagram.com/lkm_unpar/"
  //   },
  //   {
  //     name: "Himpunan Mahasiswa Program Studi Matematika UNPAR",
  //     image: "matematika_unpar_logo.png",
  //     link: "https://www.instagram.com/hmpsma.unpar/?hl=en"
  //   },
  //   {
  //     name: "Himpunan Mahasiwa Teknik Informatika Gunadarma",
  //     image: "himti_logo.png",
  //     link: "https://www.instagram.com/himtiug/"
  //   },
  //   {
  //     name: "BEM Fakultas Teknologi Industri ITS",
  //     image: "bem_fti_its.png",
  //     link: "https://www.instagram.com/bemfti_its/"
  //   }
  // ],
  //faq
  faq: "คำถามที่พบบ่อย",
  faqData: [
    {
      title: "เกี่ยวกับการแข่งขัน",
      items: [
        {
          question: "ฉันจำเป็นต้องใช้ Python ในการโค้ดดิ้งเท่านั้น?",
          answer: "ไม่จำเป็น คุณสามารถใช้ภาษาโปรแกรมไหนก็ได้ที่คุณถนัด"
        },
        {
          question:
            "ฉันไม่มีความรู้เกี่ยวกับการโค้ดดิ้งเลย ฉันยังสามารถสมัครเข้าร่วมการแข่งขันได้ไหม? ",
          answer:
            "ได้ คุณสามารถเข้าร่วมเทรนนิ่งและเวิร์คช็อปที่ออกแบบมาเพื่อการแข่งขั้นนี้เพื่อเตรียมพร้อมสำหรับการแข่งขันนี้ หรือคุณจะจับกลุ่มกับเพื่อนที่มีความสามารถในการโค้ดดิ้งเพื่อช่วยกันแก้ไขโจทย์"
        },
        {
          question:
            "จำเป็นไหมที่สมาชิกในทีมทั้งหมดจะต้องอยู่จนถึงจบการแข่งขัน?",
          answer: "จำเป็น สมาชิกทุกคนจะต้องอยู่จนถึงช่วงประกาศรางวัล"
        },
        {
          question: "สิ่งจำเป็นที่ฉันจะต้องนำมาในวันแข่งขัน?",
          answer:
            "กรุณานำคอมพิวเตอร์ ที่ชาร์จ และ อะแดปเตอร์ ทุกทีมควรมีเครื่องคอมพิวเตอร์กลางหนึ่งเครื่องที่จะใช้ในการอัพโหลดคำตอบ"
        },
        {
          question:
            "ฉันจะได้รับประกาศนียบัตรในการเข้าร่วมไหม ถึงแม้ว่าฉันจะไม่ได้รางวัลใดๆในการแข่งขัน?",
          answer: "ได้ แต่คุณจะต้องสามารถส่งคำตอบในเวลาที่กำหนดไว้ในการแข่งขัน"
        }
      ]
    },
    {
      title: "สิทธิ์และคุณสมบัติของผู้เข้าแข่งขัน",
      items: [
        {
          question:
            "ถ้าฉันไม่ได้อยู่ที่ประเทศไทย ฉันยังสามารถเข้าร่วมการแข่งขันได้ไหม?",
          answer:
            "การแข่งขันนี้เปิดให้ผู้เข้าแขางขันทุกสัญชาติ แต่จะต้องพำนัก ศึกษา หรือ ทำงานอยู่ในประเทศไทยเท่านั้น"
        },
        {
          question: "อายุต่ำสุดที่สามารถสมัครได้คือ?",
          answer:
            "คุณจะต้องมีอายุ 16 ปีบริบูรณ์ในวันที่แข่งขัน ถ้าคุณอายุไม่ถึง 16 ปีแต่มีความสนใจและมั่นใจว่ามีทักษะที่เพียงพอสำหรับการแข่งขันนี้ กรุณาส่งอีเมลล์แจ้งความจำนงเพื่อให้ทางเราพิจารณาเพิ่มเติมได้ที่  datachallengeth@shopee.com  โดยทางเราจะพิจารณาเป็นแต่ละกรณีไป"
        }
      ]
    },
    {
      title: "คุณสมบัติในการสมัครเข้าแข่งขัน",
      items: [
        {
          question:
            "ฉันสามารถรู้ได้อย่างไรว่าการสมัครแข่งขัน Thailand Data Challengeของฉันเสร็จสมบูรณ์?",
          answer:
            "คุณจะได้รับอีเมลล์คอนเฟิร์มภายใน 1-2 อาทิตย์ และถ้าคุณไม่ได้รับ กรุณารีบติดต่อที่ datachallengeth@shopee.com เพื่อตรวจสอบสถานะใบสมัคร <br/>ทั้งนี้ คุณจะต้องยืนยันรายละเอียดต่างๆตามที่แจ้งไปในอีเมลล์กลับมาภายใน วันที่ <strong>9 มีนาคม 2563, เวลา 23.59h</strong>."
        },
        {
          question: "ฉันสามารถสมัครแบบเดี่ยวได้ไหม?",
          answer: "ไม่ได้ การแข่งขันต้องแบบกลุ่มเท่านั้น"
        },
        {
          question:
            "ฉันจำเป็นต้องให้ทุกคนในทีมสมัครโดยกรอกฟอร์มรายบุคคล หรือ รายทีมไหม?",
          answer:
            "คุณจำเป็นต้องกรอกฟอร์มเข้าแข่งขันรายทีม โดยกรอกฟอร์มเพียงครั้วเดียว ระบุชื่อของสมาชิกทุกคนในทีม"
        },
        {
          question:
            "ทีมของฉันมีทั้งสมาชิกที่สมัครได้มากกว่า 1 ประเภท ฉันควรเลือกประเภทในการแข่งขันอย่างไร?",
          answer:
            "คุณจะต้องเลือกประเภทสูงสุดที่มีสมาชิกอยู่ในประเภทนั้น เช่น ถ้ามีทั้งสมาชิกที่เป็นทั้งนักศึกษาปริญญาตรี และ ปริญญาโท คุณจะต้องสมัครประเภท 3 (Open) : บุคคลทั่วไปเพราะนักศึกษาปริญญาโทอยู่ในประเภท 3 (Open)"
        },
        {
          question: "ทีมของฉันสามารถสมัครได้มากกว่า 1 ประเภทไหม?",
          answer: "ไม่ ทุกทีมสามารถได้เพียง 1 ประเภทเท่านั้น ."
        },
        {
          question:
            "ถ้าฉันกรอกฟอร์มผิด โดยระบุตัวอักษร ตัวสะกดผิดไปและอยากแก้ไขหลังจากกดส่งใบสมัครไปแล้ว ฉันจะต้องทำอย่างไร",
          answer: `กรุณาส่งรายละเอียดเข้ามาที่ datachallengeth@shopee.com ดังต่อไปนี้:  <br/>1. ชื่อของคุณ<br/>2. ชื่อทีม<br/>3. รายละเอียดที่คุณกรอกผิด<br/>4. รายละเอียดที่ถูกต้องที่ต้องการแก้ไข 
          `
        },
        {
          question:
            "ถ้าทีมของฉันต้องการเปลี่ยน หรือ ลบ หรือ เพิ่มสมาชิกฉันจะต้องทำอย่างไร ?",
          answer: `กรุณาส่งรายละเอียดเข้ามาที่ datachallengeth@shopee.com ดังต่อไปนี้: <br/>1. ชื่อของคุณ <br/>2. ชื่อทีม<br/>3. ชื่อสมาชิกที่ต้องการเปลี่ยน หรือ ลบ หรือ เพิ่ม พร้อมกับรายละเอียดอื่นๆ เช่น อาชีพ อายุ ฯลฯ 
          `
        }
      ]
    },
    {
      title: "เกี่ยวกับการฝึกอบรมและเวิร์คช้อป",
      items: [
        {
          question: "ฉันสามารถเข้าร่วมได้ทุกเทรนนิ่งและเวิร์คช็อปที่เปิดไหม?",
          answer: `โปรแกรมเทรนนิ่งและเวิร์คช็อปจะเปิดให้ลงทะเบียนก่อนสำหรับผู้สมัครลงทะเบียนเข้ามาก่อน อย่างไรก็ดี โปรแกรมเทรนนิ่งและเวิร์คช็อปของเรามีที่นั่งจำกัด คุณสามารถตรวจสอบจำนวนที่ว่างในแต่ละโปรแกรมเทรนนิ่งและเวิร์คช็อปได้ ที่ datachallengeth@shopee.com`
        }
      ]
    }
  ],

  //contact
  contactDesc01:
    "ต้องการข้อมูลเพิ่มเติมหรือมีข้อสงสัยสามารถสอบถามรายละเอียดเพิ่มเติมได้ตามอีเมลล์ด้านล่าง",
  contactBtn: "สอบถามข้อมูลเพิ่มเติม",
  contactDesc02:
    "ทั้งนี้การติดต่อสอบถามเรื่อง partnership และ tech event สามารถส่งอีเมลล์มาที่",
  contactEmail: "datachallengeth@shopee.com",
  // contactDesc03:
  //   "Semua informasi dapat berubah tanpa pemberitahuan lebih lanjut",
  //footer
  instagram: "Instagram",
  instagramLink: "https://www.instagram.com/LifeatShopee",
  linkedin: "LinkedIn",
  linkedinLink: "https://linkedin.com/company/Shopee",
  copyright: "2018-2020 Shopee All rights reserved.",
  termAndCond: "ข้อกำหนดและเงื่อนไข",
  privacy: "นโยบายคุ้มครองข้อมูลส่วนบุคคล"
};

export default translations;
